import type { Income } from '../../types';
import type { IncomeFormData } from '../forms/income-form';
import { Button } from '../ui/button';
import {
  DialogRoot,
  DialogPortal,
  DialogBackdrop,
  DialogPopup,
  DialogHeader,
  DialogTitle,
  DialogContent,
  DialogCloseButton,
} from '../ui/dialog';
import { IncomeForm } from '../forms/income-form';

interface IncomeDialogProps {
  open: boolean;
  editingIncome: Income | null;
  onSubmit: (data: IncomeFormData) => Promise<void>;
  onClose: () => void;
  incomeToDelete: Income | null;
  onDeleteConfirm: () => Promise<void>;
  onDeleteCancel: () => void;
}

export function IncomeDialog({
  open,
  editingIncome,
  onSubmit,
  onClose,
  incomeToDelete,
  onDeleteConfirm,
  onDeleteCancel,
}: IncomeDialogProps) {
  return (
    <>
      <DialogRoot
        open={open}
        onOpenChange={(isOpen) => {
          if (!isOpen) onClose();
        }}
      >
        <DialogPortal>
          <DialogBackdrop />
          <DialogPopup>
            <DialogHeader>
              <DialogTitle>
                {editingIncome ? 'Editar renda' : 'Nova renda'}
              </DialogTitle>
              <DialogCloseButton />
            </DialogHeader>
            <DialogContent>
              <IncomeForm
                onSubmit={onSubmit}
                onClose={onClose}
                initialData={editingIncome}
              />
            </DialogContent>
          </DialogPopup>
        </DialogPortal>
      </DialogRoot>

      <DialogRoot
        open={!!incomeToDelete}
        onOpenChange={(isOpen) => {
          if (!isOpen) onDeleteCancel();
        }}
      >
        <DialogPortal>
          <DialogBackdrop />
          <DialogPopup className="max-w-sm">
            <DialogHeader>
              <DialogTitle>Confirmar exclusão</DialogTitle>
              <DialogCloseButton />
            </DialogHeader>
            <DialogContent>
              <p className="text-sm text-foreground-subtle">
                Tem certeza que deseja excluir a renda{' '}
                <strong className="text-foreground">
                  {incomeToDelete?.title}
                </strong>
                ?
              </p>
              <div className="mt-4 flex gap-2">
                <Button
                  variant="outline"
                  className="flex-1"
                  onClick={onDeleteCancel}
                >
                  Cancelar
                </Button>
                <Button
                  variant="destructive"
                  className="flex-1"
                  onClick={onDeleteConfirm}
                >
                  Excluir
                </Button>
              </div>
            </DialogContent>
          </DialogPopup>
        </DialogPortal>
      </DialogRoot>
    </>
  );
}
